import React, { useEffect, useState } from 'react';
interface PriceDisplayProps {
  amount: string | number;
  originalAmount?: string | number;
  className?: string;
  fixedSymbol?: string;
}
export function PriceDisplay({
  amount,
  originalAmount,
  className = '',
  fixedSymbol
}: PriceDisplayProps) {
  const [symbol, setSymbol] = useState('US$');
  useEffect(() => {
    if (fixedSymbol) return;
    try {
      const lang = navigator.language || 'en-US';
      const lowerLang = lang.toLowerCase();
      if (lowerLang.startsWith('es-ar') || lowerLang.startsWith('es-cl') || lowerLang.startsWith('es-co')) {
        setSymbol('$');
      } else if (lowerLang.startsWith('en-gb')) {
        setSymbol('£');
      } else if (['de', 'fr', 'it', 'es-es'].some(l => lowerLang.startsWith(l))) {
        setSymbol('€');
      } else if (lowerLang.startsWith('pt-br')) {
        setSymbol('R$');
      } else {
        setSymbol('US$');
      }
    } catch (e) {
      setSymbol('US$');
    }
  }, [fixedSymbol]);
  const displaySymbol = fixedSymbol || symbol;
  return <span className={`inline-flex items-baseline ${className}`} data-id="element-198">
      {originalAmount && <span className="line-through opacity-60 mr-3 text-lg md:text-xl font-normal" data-id="element-199">
          {displaySymbol}&nbsp;{originalAmount}
        </span>}
      <span className="font-bold" data-id="element-200">
        {displaySymbol}&nbsp;{amount}
      </span>
    </span>;
}